import React from 'react';
import PropTypes from 'prop-types';
import VisibilitySensor from 'react-visibility-sensor';
import { Icon, Tooltip } from '@ontruck/orc';

import Alerts from 'modules/Common/Alerts';

import { StyledMonitorIcon } from './styled';

const MonitorIcon = ({ size, color }) => {
  return (
    <StyledMonitorIcon>
      <Icon glyph="eye" color={color} size={size} />
    </StyledMonitorIcon>
  );
};

const alertIcons = {
  WARNING: <Icon glyph="alert" color="error700" size="2.4rem" />,
  MONITOR: <MonitorIcon color="white" size="1.7rem" />,
};

const AlertsCell = React.memo(({ review, created_at, ref, alerts_status, ...item }) => {
  if (alerts_status === 'RESOLVED' || !alertIcons[alerts_status]) {
    return null;
  }

  return (
    <VisibilitySensor containment={ref} offset={{ bottom: 200 }}>
      {({ isVisible }) => {
        return (
          <Tooltip
            component={<Alerts reviewUrl={review} item={item} />}
            skin="light"
            position={isVisible ? 'bottom' : 'top'}
            bodySize="M"
          >
            {alertIcons[alerts_status]}
          </Tooltip>
        );
      }}
    </VisibilitySensor>
  );
});

AlertsCell.propTypes = {
  created_at: PropTypes.string.isRequired,
  reviewTimeAlert: PropTypes.number.isRequired,
  review: PropTypes.string.isRequired,
  alerts_status: PropTypes.string,
  ref: PropTypes.any,
};

export default AlertsCell;
